import {startCase} from "lodash"
import {ProgramPerformanceItem} from "../../ProgramPerformanceItemCard/types"
import {IcomoonIconName} from "../../Icon/icons"

export type PerformanceKey = "customers" | "accounts" | "depositBalance" | "cards"

type ItemConfig = {
	key: PerformanceKey
	icon: IcomoonIconName
	formatAsCurrency?: boolean
}

const performanceConfigs: ItemConfig[] = [
	{key: "customers", icon: "user-geometric-action-money-fund---users"},
	{key: "accounts", icon: "bank-account--business-products"},
	{key: "depositBalance", icon: "payment-box-reserve", formatAsCurrency: true},
	{key: "cards", icon: "credit-card"},
]

export const getPerformanceItems = (valuesMap: Record<PerformanceKey, string>): ProgramPerformanceItem[] =>
	performanceConfigs.map((cfg) => ({
		title: startCase(cfg.key),
		icon: cfg.icon,
		...(cfg.formatAsCurrency && {formatAsCurrency: true}),
		value: valuesMap[cfg.key],
	}))
